import React, { Component } from 'react';
import {
	FormText,
} from 'reactstrap';
import {I18n} from '../../../I18n/components/createCompany';
import './step2.css';

export default class Step2 extends Component {
	constructor(props) {
		super(props);

		this.state = {
			manager: props.getStore().manager,
			phone: props.getStore().phone,
			email: props.getStore().email,
			skype: props.getStore().skype,
		};
		this._validateOnDemand = true; // this flag enables onBlur validation as user fills forms

		this.validationCheck = this.validationCheck.bind(this);
		this.isValidated = this.isValidated.bind(this);
	}
	isValidated() {
		const userInput = this._grabUserInput(); // grab user entered vals
		const validateNewInput = this._validateData(userInput); // run the new input against the validator
		let isDataValid = false;

		// if full validation passes then save to store and pass as valid
		if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === true })) {
			if (
				this.props.getStore().manager !== userInput.manager ||
				this.props.getStore().phone !== userInput.phone ||
				this.props.getStore().email !== userInput.email //||
				//this.props.getStore().skype !== userInput.skype
			) { // only update store of something changed
				this.props.updateStore({
					...userInput,
					savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
				});  // Update store here (this is just an example, in reality you will do it via redux or flux)
			}

			isDataValid = true;
		}
		else {
			// if anything fails then update the UI validation state but NOT the UI Data State
			this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
		}

		return isDataValid;
	}

	validationCheck() {
		if (!this._validateOnDemand)
			return;

		const userInput = this._grabUserInput(); // grab user entered vals
		const validateNewInput = this._validateData(userInput); // run the new input against the validator

		this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
	}

	_validateData(data) {
		return  {
			managerVal: (data.manager !== ""),
			phoneVal: /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(data.phone),
			//skypeVal: (data.skype == ""), // required: anything besides N/A
			emailVal: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(data.email), // required: regex w3c uses in html5
		}
	}

	_validationErrors(val) {
		const errMsgs = {
			managerValMsg: val.managerVal ? '' : `${I18n[this.props.lang].stepTwo.managerRequired}`,
			phoneValMsg: val.phoneVal ? '' : `${I18n[this.props.lang].stepTwo.phoneRequired}`,
			// skypeValMsg: val.skypeVal ? '' : `${I18n[this.props.lang].stepTwo.skypeRequired}`,
			emailValMsg: val.emailVal ? '' : `${I18n[this.props.lang].stepTwo.mailRequired}`
		}
		return errMsgs;
	}

	_grabUserInput() {
		return {
			manager: this.refs.manager.value,
			phone: this.refs.phone.value,
			skype: this.refs.skype.value,
			email: this.refs.email.value
		};
	}
	render() {
		const {lang} = this.props;
		// explicit class assigning based on validation
		let notValidClasses = {};
		if (typeof this.state.managerVal === 'undefined' || this.state.managerVal) {
			notValidClasses.managerCls = 'form-control';
		}
		else {
			notValidClasses.managerCls = 'is-invalid form-control';
			notValidClasses.managerValGrpCls = 'text-danger';
		}
		if (typeof this.state.phoneVal === 'undefined' || this.state.phoneVal) {
			notValidClasses.phoneCls = 'form-control';
		}
		else {
			notValidClasses.phoneCls = 'is-invalid form-control';
			notValidClasses.phoneValGrpCls = 'text-danger';
		}
		if (typeof this.state.skypeVal === 'undefined' || this.state.skypeVal) {
			notValidClasses.skypeCls = 'form-control';
		}
		else {
			notValidClasses.skypeCls = 'is-invalid form-control';
			notValidClasses.skypeValGrpCls = 'text-danger';
		}
		if (typeof this.state.emailVal === 'undefined' || this.state.emailVal) {
			notValidClasses.emailCls = 'form-control';
		}
		else {
			notValidClasses.emailCls = 'is-invalid form-control';
			notValidClasses.emailValGrpCls = 'text-danger';
		}
		return (
			<div className="step step2 mt-5 company-step">
				<div className="row justify-content-md-center">
					<div className="col col-lg-6">
						<div className="">
							<form id="Form" className="form-horizontal mt-2">
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">
										{I18n[lang].stepTwo.manager}
									</label>
									<div className="col-sm-9">
										<input
											ref="manager"
											autoComplete="off"
											type="text"
											placeholder={I18n[lang].stepTwo.manager}
											className={notValidClasses.managerCls}
											required
											defaultValue={this.state.manager}
											onBlur={this.validationCheck} />
										<FormText className="text-muted">{I18n[lang].stepTwo.innerUsage}</FormText>
										<div className={notValidClasses.managerValGrpCls}>{this.state.managerValMsg}</div>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">
										{I18n[lang].stepTwo.phone}
									</label>
									<div className="col-sm-9">
										<input
											ref="phone"
											autoComplete="off"
											type="text"
											placeholder={I18n[lang].stepTwo.phone}
											className={notValidClasses.phoneCls}
											required
											defaultValue={this.state.phone}
											onBlur={this.validationCheck} />
										<FormText className="text-muted">{I18n[lang].stepTwo.innerUsage}</FormText>
										<div className={notValidClasses.phoneValGrpCls}>{this.state.phoneValMsg}</div>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">
										{I18n[lang].stepTwo.email}
									</label>
									<div className="col-sm-9">
										<input
											ref="email"
											autoComplete="off"
											type="email"
											placeholder="john.smith@example.com"
											className={notValidClasses.emailCls}
											required
											defaultValue={this.state.email}
											onBlur={this.validationCheck} />
										<div className={notValidClasses.emailValGrpCls}>{this.state.emailValMsg}</div>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">
										{I18n[lang].stepTwo.skype}
									</label>
									<div className="col-sm-9">
										<input
											ref="skype"
											autoComplete="off"
											type="email"
											placeholder={I18n[lang].stepTwo.skype}
											className={notValidClasses.skypeCls}
											defaultValue={this.state.skype}
											onBlur={this.validationCheck} />
										<div className={notValidClasses.skypeValGrpCls}>{this.state.skypeValMsg}</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/CreateCompany/Step2/Step2.js